export const SET_USER = "SET_USER";
export const ADD_FOLLOWING = "ADD_FOLLOWING";
export const REMOVE_FOLLOWING = "REMOVE_FOLLOWING";
export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const REMOVE_PROFILE_PICTURE = "REMOVE_PROFILE_PICTURE";
export const ADD_PROFILE_PICTURE = "ADD_PROFILE_PICTURE";
export const LOGOUT = "LOGOUT";
